export default "__VITE_ASSET__BiYTKYeO__"